export default __webpack_public_path__ + "static/media/close.4b786d05.svg";